import { BillingAction } from './billing.action';
import { InitializerAction } from '../initializer/initiliazer.action';

export interface BillingState {
    error: any;
    pending: boolean;
    brokerageTax: any;
    brokerageModel: {
        type: number|string,
        description: 'unknown'|'traditional'|'winwin'
    };
    monthlyScore : {
        month: number;
        year: number;
        xbmfDetails: Array<{
            calcTypeID : number,
            value: number
        }>;
        xbspDetails: Array<{
            calcTypeID : number,
            value: number
        }>;
    };
    loadingMonthlyScore : boolean;
}

export const initialGenericState: BillingState = {
    error: null,
    pending: false,
    brokerageTax: null,
    brokerageModel: {
        type: null,
        description: null
    },
    monthlyScore : null,
    loadingMonthlyScore: false
};

export function BillingReducer(state: BillingState = initialGenericState, action: any) :BillingState {

    switch (action.type) {

        case BillingAction.getBrokerageTaxSuccess: {
            return {
                ...state,
                ...{
                    brokerageTax: action.payload.brokerageValue,
                    pending: false,
                    error: null
                }
            };
        }

        case BillingAction.getBrokerageTaxError: {
            return {
                ...state,
                ...{
                    pending: false,
                    error: action.payload
                }
            };
        }

        case BillingAction.getLastMonthlyScore : {
            return {
                ...state,
                ...{
                    loadingMonthlyScore: true
                }
            }
        }

        case BillingAction.getLastMonthlyScoreError: {
            return {
                ...state,
                ...{
                    loadingMonthlyScore: false,
                    error: action.payload
                }
            };
        }

        case BillingAction.getLastMonthlyScoreSuccess: {
            return {
                ...state, 
                ...{
                    loadingMonthlyScore: false,
                    monthlyScore: action.payload
                }
            }
        }
        
        case InitializerAction.resetUserRelatedData: {
            return {
                ...state,
                ...{
                    brokerageTax: initialGenericState.brokerageTax
                }
            };
        }

        case BillingAction.getBrokerageModelSuccess: {
            return Object.assign({}, state, {brokerageModel: action.payload});
        }

        case BillingAction.setBrokerageModelSuccess: {
            return Object.assign({}, state, {brokerageModel: action.payload});
        }

        default: {
            return state;
        }

    }
};
